import React, { useState } from "react";
import { Switch, Route, Redirect, Router } from "react-router-dom";
import "./App.css";
import { createBrowserHistory } from "history";
import {
  NavUtils,
  StorageUtils,
  OpenIdUtils,
} from "./utils";
import {
  APP_USER_SESSION,
  AUTH_STATE,
  LOCAL_STORAGE,
} from "./constant/AppConstants";
import DashboardLayout from "./layouts/Dashboard/DashboardLayout";
import { Toaster } from "react-hot-toast";
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
import Page404 from "./pages/404";
import { setUserRole } from "./services/services";
import Maintenance from "./pages/Maintenance";
import { UserProvider } from "./context/userContext";
import CircularLoader from "./components/circularLoader";
import { Box } from "@mui/material";

// theme Required for GW2
import "normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "@blueprintjs/table/lib/css/table.css";
import LoadingSpinnerGlobal from "./components/loading-spinner";
import { LoadingSpinnerProvider } from "./context/loadingSpinnerContext";
import { isShowAlertPermission } from "./utils/toast";
import { getUser } from "./services/token.service";
import { logout } from "./utils/openidUtils";
import { Auth } from "aws-amplify";

function App() {
  const [flag, setFlag] = useState(false);
  const [role, setRole] = useState(false);
  const browserHistory = createBrowserHistory();

  const checkUserAuth = async () => {
    try {
      const session = await Auth.currentSession();
      const userInfo = await Auth.currentUserInfo();

      const accessToken = session.getAccessToken().getJwtToken();
      console.log("User session is valid: ", session);
      return {
        isAuthenticated: true,
        accessToken,
        email: userInfo?.attributes?.email,
        payload: session.getAccessToken().payload,
      };
    } catch (error) {
      return {
        isAuthenticated: false,
      };
    }
  }

  StorageUtils.setValue(
    LOCAL_STORAGE.COGNITO.REACT_APP_GW3_MCP_LOGIN_URL,
    process.env.REACT_APP_GW3_MCP_LOGIN_URL
  );
  StorageUtils.setValue(
    LOCAL_STORAGE.COGNITO.REACT_APP_GW3_COGNITO_POOLS_ID,
    process.env.REACT_APP_GW3_COGNITO_POOLS_ID
  );
  const cognitoSession = checkUserAuth();
  
  const userSession = StorageUtils.getParsedValue(APP_USER_SESSION);

  cognitoSession.then((session) => {
    if (session && session.isAuthenticated && !flag) {
      const token = session.accessToken;
      const email = session.email;
      const payload = session.payload;
      OpenIdUtils.setTokenExpired(token, payload.exp, payload.auth_time);
      OpenIdUtils.setUserInSession(
        payload.username || payload["cognito:username"],
        payload.client_id,
        email,
        AUTH_STATE.SignedIn,
        setRole,
        setFlag
      );
    } else if (userSession.state !== AUTH_STATE.SignedIn) {
      console.log("User session state is not signed in, redirecting to login.");
      NavUtils.appRedirect();
    } else if (!OpenIdUtils.tokenIsNotExpired()) {
      console.log("User session token is expired, redirecting to login.");
      NavUtils.appRedirect();
    } else if (!getUser()) {
      console.log("No user found in session, logging out.");
      logout();
    } else if (userSession.state === AUTH_STATE.SignedIn && !role && getUser()) {
      console.log("User is signed in but role is not set, fetching user role.");
      setUserRole(setRole);
    }
  }).catch((error) => {
    console.error("Error checking user authentication: ", error);
  });

  if (role) {
    return (
      <UserProvider>
        <Router history={browserHistory}>
          <ThemeConfig>
            <GlobalStyles />
            <Toaster />
            <LoadingSpinnerProvider>
              <Switch>
                <Route
                  path="/3/app"
                  render={(props) => <DashboardLayout {...props} />}
                />
                <Route path="/maintenance" component={Maintenance} />
                <Route exact path="/404" component={Page404} />
                {(flag || OpenIdUtils.tokenIsNotExpired()) && (
                  (() => {
                    if (isShowAlertPermission()) return
                    return <Redirect to={"/3/app/transactions/"} />
                  })()
                )}
              </Switch>
              <LoadingSpinnerGlobal />
            </LoadingSpinnerProvider>
          </ThemeConfig>
        </Router>
      </UserProvider>
    );
  } else {
    return (
      <>
        <Toaster />
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}>
          <CircularLoader size={40} />
        </Box>
      </>
    );
  }
}

export default App;
